const shouldAnimate = () => !window.matchMedia('(prefers-reduced-motion: reduce), (update: slow)').matches;

export default shouldAnimate;
